import { Button } from '@achieve/ascend'
import { AchieveLink } from 'components/AchieveLink/AchieveLink'
import { MediaImageStandard, Typography } from 'components/Contentful'
import { CurrentSvg } from 'components/CurrentSvg'
import Link from 'next/link'

export const FDRHeader = ({
  siteEnv,
  tp_text,
  tp_image,
  linkUrl,
  phoneData,
  logoLink,
  mainProductConfig,
  backLink,
  logoEvent,
}) => {
  const phoneNumber = phoneData?.phoneNumber
    ? phoneData.phoneNumber.replace('(', '').replace(')', '').replace(' ', '-')
    : '800-910-0065'
  return (
    <div className="py-4 drop-shadow-md bg-white fixed top-0 left-0 right-0 z-30">
      <div className="flex flex-row justify-between items-center gap-x-5 w-full max-w-[1000px] mx-auto">
        {logoLink ? (
          <AchieveLink
            track={{
              ...{
                list_name: 'Header Logo',
                click_id: `${mainProductConfig[siteEnv || 'achieve']?.['HeaderLogo']}`,
                click_text: `${
                  mainProductConfig[siteEnv || 'achieve']?.['MainProductHyphen']
                } | Header logo`,
                nav_link_section: 'Header logo',
                track_event: 'global_header',
                event_action: 'link_click',
                event_type: 'link_click',
              },
              ...logoEvent,
            }}
            href={backLink}
            withNextLink
            data-testid={`${String(
              mainProductConfig[siteEnv || 'achieve']?.['MainName']
            )?.toLowerCase()}-header-logo`}
          >
            <CurrentSvg siteEnv={siteEnv} width={112} height={48} />
          </AchieveLink>
        ) : (
          <CurrentSvg siteEnv={siteEnv} width={112} height={48} />
        )}
        <Typography
          content="Get credit card debt relief from America’s top debt relief company."
          className="whitespace-nowrap text-sm -translate-y-3"
        />
        <div className="flex flex-col items-center gap-2">
          <div className="flex flex-row gap-4">
            <Button
              component="a"
              href={`tel:${phoneNumber}`}
              className="bg-white border-2 border-[#041B93] border-solid text-[#041B93] px-5 py-2 rounded-md no-underline"
            >
              <Typography
                content={`Call ${phoneNumber}`}
                className="whitespace-nowrap text-base font-bold text-[#041B93]"
              />
            </Button>
            {linkUrl && (
              <Link href={linkUrl} className="no-underline">
                <Button className="group bg-[#CB000E] px-5 py-2 rounded-md flex items-center gap-2">
                  <Typography
                    content="See if you qualify"
                    className="text-white whitespace-nowrap text-lg font-bold"
                  />
                </Button>
              </Link>
            )}
          </div>
          <div className="flex flex-row gap-2 lg:block">
            <div className="flex flex-row gap-2 items-center justify-center">
              <div className="w-[180px] h-[28px]">
                <MediaImageStandard content={tp_image} />
              </div>
              <Typography className="text-black text-base" content={tp_text} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
